import ApiService from "@/common/api.service";
import JwtService from "@/common/jwt.service";
import {
  LOGIN,
  FETCH_USER,
  FETCH_TAXONOMIES,
  FETCH_TARGETS,
  LOGOUT 
} from "./actions.type";
import {
	SET_AUTH,
  SET_USER,
	PURGE_AUTH,
  SET_TAXONOMIES,
  SET_TARGETS
} from "./mutations.type";

const state = {
  user: {},
  key: null,
  isAuthenticated: !!JwtService.getToken(),
  taxonomies: [],
  targets: [],
  taxonomiesNames: [],
  targetsNames: []
};

const getters = {
  key(state) {
    return state.key;
  },
  user(state) {
    return state.user;
  },
  isAuthenticated(state) {
    return state.isAuthenticated;
  },
  taxonomies(state) {
    return state.taxonomies;
  },
  targets(state) {
    return state.targets;
  },
  taxonomiesNames(state) {
    return state.taxonomiesNames;
  },
  targetsNames(state) {
    return state.targetsNames;
  }
};

const actions = {
  [LOGIN](context, credentials) {
    return new Promise(resolve => {
      // ApiService.post("rest-auth/login/", credentials)
      ApiService.post("custom/login/operator/", credentials)
        .then(({ data }) => {
          console.log(data);
          context.commit(SET_AUTH, data.key);
          resolve(data);
        })
        .catch(({ error }) => {
          console.log('error', error);
        });
    });
  },
  [FETCH_USER](context) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get("profile_info/")
        .then(({ data }) => {
          context.commit(SET_USER, data.data);
          resolve(data);
        })
    });
  },
  [FETCH_TAXONOMIES](context) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get("taxonomies/")
        .then(({ data }) => {
          context.commit(SET_TAXONOMIES, data);
          resolve(data);
        })
    });
  },
  [FETCH_TARGETS](context) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get("gandtargets/")
        .then(({ data }) => {
          context.commit(SET_TARGETS, data);
          resolve(data);
        })
    });
  },
  [LOGOUT](context) {
    context.commit(PURGE_AUTH);
  },
};

const mutations = {
  [SET_AUTH](state, key) {
    state.isAuthenticated = true;
    state.key = key;
    JwtService.saveToken(state.key);
  },
  [SET_USER](state, user) {
    state.user = user;
  },
  [PURGE_AUTH](state) {
    window.localStorage.removeItem('appVuex'); 
    state.isAuthenticated = false;
    state.user = {};
    state.key = null;
    state.taxonomies = [];
    state.targets = [];
    JwtService.destroyToken();
  },
  [SET_TAXONOMIES](state, taxonomies) {
    state.taxonomies = taxonomies;
    let taxNamesArray = {};
    for (var i = taxonomies.length - 1; i >= 0; i--) {
      taxNamesArray[taxonomies[i].tax_id] = taxonomies[i].label;
    }
    state.taxonomiesNames = taxNamesArray;
  },
  [SET_TARGETS](state, targets) {
    state.targets = targets;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};